/* @generated */

// src/assets/ui-icon/fill/verified.tsx
import * as React from "react";
var VerifiedFill = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.592 4.584a1.884 1.884 0 0 1 2.816 0c.453.51 1.146.735 1.812.589a1.884 1.884 0 0 1 2.278 1.655 1.884 1.884 0 0 0 1.12 1.541 1.884 1.884 0 0 1 .87 2.679 1.884 1.884 0 0 0 0 1.904c.57.974.163 2.227-.87 2.679a1.884 1.884 0 0 0-1.12 1.54 1.884 1.884 0 0 1-2.278 1.656 1.884 1.884 0 0 0-1.812.589 1.884 1.884 0 0 1-2.816 0 1.884 1.884 0 0 0-1.812-.589 1.884 1.884 0 0 1-2.278-1.655 1.884 1.884 0 0 0-1.12-1.541 1.884 1.884 0 0 1-.87-2.679 1.884 1.884 0 0 0 0-1.904 1.884 1.884 0 0 1 .87-2.679 1.884 1.884 0 0 0 1.12-1.54A1.884 1.884 0 0 1 8.78 5.172a1.884 1.884 0 0 0 1.812-.589Zm5.438 5.446-1.06-1.06L11 12.94l-1.97-1.97-1.06 1.06L11 15.06l5.03-5.03Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  VerifiedFill
};
